export default {
  applyPolyfills: () => {
  
    if (!Number.parseInt) Number.parseInt = parseInt;
    if (!Number.parseFloat) Number.parseFloat = parseFloat;
  
    if (!Array.prototype.includes) {
      Array.prototype.includes = function(searchElement /*, fromIndex*/) {
        'use strict';
        if (this == null) {
          throw new TypeError('Array.prototype.includes called on null or undefined');
        }
      
        var O = Object(this);
        var len = parseInt(O.length, 10) || 0;
        if (len === 0) {
          return false;
        }
        var n = parseInt(arguments[1], 10) || 0;
        var k;
        if (n >= 0) {
          k = n;
        } else {
          k = len + n;
          if (k < 0) {k = 0;}
        }
        var currentElement;
        while (k < len) {
          currentElement = O[k];
          if (searchElement === currentElement ||
            (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
            return true;
          }
          k++;
        }
        return false;
      };
    }
    if (![].entries) {
      Array.prototype.entries = function() {
        var k, a = [], nextIndex = 0, ary = this;
        k = ary.length;
        while (k > 0) a[--k] = [k,ary[k]];
        a.next = function(){
          return nextIndex < ary.length ?
          {value: [nextIndex++,ary[nextIndex]], done: false} :
          {done: true};
        };
        return a;
      };
    }
  
    if (![].keys) {
      Array.prototype.keys = function() {
        var k, a = [], nextIndex = 0, ary = this;
        k = ary.length;
        while (k > 0) a[--k] = k;
        a.next = function(){
          return nextIndex < ary.length ?
          {value: nextIndex++, done: false} :
          {done: true};
        };
        return a;
      };
    }
  
    if (![].values) {
      Array.prototype.values = function() {
        var k, a = [], nextIndex = 0, ary = this;
        k = ary.length;
        while (k > 0) a[--k] = ary[k];
        a.next = function(){
          return nextIndex < ary.length ?
          {value: ary[nextIndex++], done: false} :
          {done: true};
        };
        return a;
      };
    }
  
    if (!Map) {
      //! Copyright 2012 Eric Wendelin - MIT License
      (function(a){function b(a){var b=[],c=[],f=[],j=Object.is||function(d,a){return d===a?0!==d||1/d==1/a:d!=d&&a!=a},g=function(d){if(d!=d||0===d)for(var a=this.length;a--&&!j(this[a],d););else a=[].indexOf.call(this,d);return a},k=function(d,a){var b=0;return Object.create({},{next:{value:function(){if(b<d.items().length)switch(a){case "keys":return d.keys()[b++];case "values":return d.values()[b++];case "keys+values":return[].slice.call(d.items()[b++]);default:throw new TypeError("Invalid iterator type");
      }throw Error("Stop Iteration");}},iterator:{value:function(){return this}},toString:{value:function(){return"[object Map Iterator]"}}})},h=function(d,a){var e=g.call(c,d);-1<e?(b[e]=a,f[e]=a):(b.push([d,a]),c.push(d),f.push(a))},l=function(a){if(2!==a.length)throw new TypeError("Invalid iterable passed to Map constructor");h(a[0],a[1])};if(Array.isArray(a))a.forEach(l);else if(void 0!==a)throw new TypeError("Invalid Map");return Object.create(e,{items:{value:function(){return[].slice.call(b)}},keys:{value:function(){return[].slice.call(c)}},
        values:{value:function(){return[].slice.call(f)}},has:{value:function(a){return-1<g.call(c,a)}},get:{value:function(a){a=g.call(c,a);return-1<a?f[a]:void 0}},set:{value:h},size:{get:function(){return b.length}},clear:{value:function(){c.length=f.length=b.length=0}},"delete":{value:function(a){a=g.call(c,a);return-1<a?(c.splice(a,1),f.splice(a,1),b.splice(a,1),!0):!1}},forEach:{value:function(a,b){function c(){try{return e.next()}catch(a){}}if("function"!=typeof a)throw new TypeError("Invalid callback function given to forEach");
          for(var e=this.iterator(),f=c(),g=c();void 0!==f;)a.apply(b,[f[1],f[0],this]),f=g,g=c()}},iterator:{value:function(){return new k(this,"keys+values")}},toString:{value:function(){return"[Object Map]"}}})}var c=(a="undefined"==a)?this:global,a=a?{}:exports,e=b.prototype;b.prototype=e=b();c.Map=a.Map=c.Map||b}).call(this,typeof exports);
      (function(){Map.prototype.filter=function(a){if("function"!=typeof a)throw new TypeError("Expected a function argument");var b=new Map;this.forEach(function(c,e,i){a(e,c,i)&&b.set(e,c)});return b};Map.prototype.merge=function(a){function b(a,b){c.set(b,a)}if(!(a instanceof Map))throw new TypeError("Cannot merge with objects that are not Maps");var c=new Map;this.forEach(b);a.forEach(b);return c};Map.prototype.fetch=function(a,b){return this.has(a)?this.get(a):b};Map.prototype.invert=function(){var a=
        new Map;this.forEach(a.set);return a};Map.prototype.reject=function(a){if("function"!=typeof a)throw new TypeError("Expected a function argument");this.forEach(function(b,c,e){if(a(c,b,e))e["delete"](c)}.bind(this))};Map.prototype.isEmpty=function(){return 0===this.keys().length}})();
    }
  
    // Production steps of ECMA-262, Edition 6, 22.1.2.1
    if (!Array.from) {
      Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
          return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
          var number = Number(value);
          if (isNaN(number)) { return 0; }
          if (number === 0 || !isFinite(number)) { return number; }
          return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
          var len = toInteger(value);
          return Math.min(Math.max(len, 0), maxSafeInteger);
        };
      
        // The length property of the from method is 1.
        return function from(arrayLike/*, mapFn, thisArg */) {
          // 1. Let C be the this value.
          var C = this;
        
          // 2. Let items be ToObject(arrayLike).
          var items = Object(arrayLike);
        
          // 3. ReturnIfAbrupt(items).
          if (arrayLike == null) {
            throw new TypeError("Array.from requires an array-like object - not null or undefined");
          }
        
          // 4. If mapfn is undefined, then let mapping be false.
          var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
          var T;
          if (typeof mapFn !== 'undefined') {
            // 5. else
            // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
            if (!isCallable(mapFn)) {
              throw new TypeError('Array.from: when provided, the second argument must be a function');
            }
          
            // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 2) {
              T = arguments[2];
            }
          }
        
          // 10. Let lenValue be Get(items, "length").
          // 11. Let len be ToLength(lenValue).
          var len = toLength(items.length);
        
          // 13. If IsConstructor(C) is true, then
          // 13. a. Let A be the result of calling the [[Construct]] internal method
          // of C with an argument list containing the single item len.
          // 14. a. Else, Let A be ArrayCreate(len).
          var A = isCallable(C) ? Object(new C(len)) : new Array(len);
        
          // 16. Let k be 0.
          var k = 0;
          // 17. Repeat, while k < len… (also steps a - h)
          var kValue;
          while (k < len) {
            kValue = items[k];
            if (mapFn) {
              A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
            } else {
              A[k] = kValue;
            }
            k += 1;
          }
          // 18. Let putStatus be Put(A, "length", len, true).
          A.length = len;
          // 20. Return A.
          return A;
        };
      }());
    }
    
  }
};
